export default __webpack_public_path__ + "static/media/2.56a58e71.webp";